import { MapStyle } from "@components/world-map/world-map-types";

/** All supported world map styles. */
const MAP_STYLES = ["colored", "satellite"] satisfies MapStyle[];

/**
 * Type guard that checks whether a stored value is a supported map style.
 * @param value - The value to check.
 * @returns True if the value is a valid MapStyle, false otherwise.
 */
export function isMapStyle(value: string | null): value is MapStyle {
  return value !== null && (MAP_STYLES as string[]).includes(value);
}
